import * as React from "react";
import CreateIndpForm from "../../components/Forms/IndustrialPremises/FlowForm/FlowForm";

export default function CreateIndp() {
  return <CreateIndpForm />;
}
